import { LearningItem } from '../../models/LearningItem'

export default function bookingForLearningItem(learningItem?: LearningItem) {
  if (!learningItem) {
    return null
  }

  if (learningItem.kind === 'onDemandCourse') {
    // !IMPORTANT: The booking attached to the OnDemandCourse entity
    // relates to the currently logged-in user
    return learningItem.onDemandCourse.booking
  }

  if (learningItem.kind === 'scheduledCourse') {
    // !IMPORTANT: The booking attached to the ScheduledCourseEvent entity
    // relates to the currently logged-in user
    return learningItem.scheduledCourse.events.find(({ booking }) => booking)?.booking
  }

  return null
}

/**
 * It searches for bookings in an attendee's relationship.
 *
 * @param userUuid
 * @param learningItem
 */
export function firstBookingForLearningItemForUserUuid(userUuid: string, learningItem: LearningItem) {
  if (learningItem.kind === 'onDemandCourse') {
    return learningItem.onDemandCourse.bookings?.find((booking) => booking.userUuid === userUuid)
  }

  if (learningItem.kind === 'scheduledCourse') {
    return learningItem.scheduledCourse.events
      .flatMap((event) => event.dates)
      .flatMap((date) => date.attendees || [])
      .find((attendee) => attendee.booking.userUuid === userUuid)?.booking
  }

  return null
}
